import { useState, useEffect } from 'react';

const navLinks = [
  { label: 'Cómo pides', href: '#como-pides' },
  { label: 'Cobertura', href: '#cobertura' },
  { label: 'Qué llevamos', href: '#que-llevamos' },
  { label: 'Visítanos', href: '#visitanos' },
  { label: 'FAQ', href: '#faq' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <header
        className={`sticky top-0 z-50 border-b transition-all duration-300 ${
          scrolled
            ? 'border-md-sky/60 bg-white/90 backdrop-blur-md shadow-sm'
            : 'border-transparent bg-white/70 backdrop-blur-sm'
        }`}
      >
        <div className="mx-auto flex h-[72px] max-w-[1280px] items-center justify-between px-6 md:px-12">
          <a href="/" className="flex items-center gap-3">
            <img
              src="https://static.readdy.ai/image/100c669628d567e493b0574d25985585/fdd0fbd9bd30abc0ce68dc53ed7f4af7.jpeg"
              alt="Logo Multidroguerías"
              className="h-12 w-12 rounded-lg object-cover"
            />
            <div className="flex flex-col">
              <span className="font-serif text-[18px] font-bold leading-tight text-md-ink">
                Multidroguerías
              </span>
              <span className="text-[11px] font-medium text-md-slate">
                Servicio de domicilio
              </span>
            </div>
          </a>

          <nav className="hidden items-center gap-8 md:flex">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="group relative text-[15px] font-medium text-md-ink transition-colors hover:text-md-dark"
              >
                {link.label}
                <span className="absolute -bottom-1 left-1/2 h-0.5 w-0 -translate-x-1/2 rounded-full bg-md-teal transition-all duration-200 group-hover:w-full" />
              </a>
            ))}
          </nav>

          <a
            href="tel:+573206789030"
            className="hidden items-center gap-2 rounded-full border-2 border-md-dark px-5 py-2.5 text-[14px] font-semibold text-md-dark transition-all hover:bg-md-dark hover:text-white md:flex"
            onClick={() => {
              if (typeof window !== 'undefined' && (window as unknown as Record<string, unknown>).mdCallClick) {
                ((window as unknown as Record<string, unknown>).mdCallClick as () => void)();
              }
            }}
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-phone-line" />
            </span>
            Llamar
          </a>

          <button
            type="button"
            className="flex h-10 w-10 items-center justify-center text-md-ink md:hidden"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label={mobileOpen ? 'Cerrar menú' : 'Abrir menú'}
            aria-expanded={mobileOpen}
          >
            <span className="flex h-5 w-5 items-center justify-center">
              <i className={mobileOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
            </span>
          </button>
        </div>
      </header>

      {mobileOpen && (
        <div className="fixed inset-0 z-40 bg-white/98 backdrop-blur-lg md:hidden">
          <nav className="flex flex-col items-center justify-center gap-8 pt-32">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="text-2xl font-medium text-md-ink transition-colors hover:text-md-dark"
                onClick={() => setMobileOpen(false)}
              >
                {link.label}
              </a>
            ))}
            <a
              href="tel:+573206789030"
              className="mt-4 flex items-center gap-2 rounded-full bg-md-dark px-8 py-3 text-lg font-semibold text-white"
              onClick={() => {
                setMobileOpen(false);
                if (typeof window !== 'undefined' && (window as unknown as Record<string, unknown>).mdCallClick) {
                  ((window as unknown as Record<string, unknown>).mdCallClick as () => void)();
                }
              }}
            >
              <span className="flex h-5 w-5 items-center justify-center">
                <i className="ri-phone-line" />
              </span>
              Llamar ahora
            </a>
          </nav>
        </div>
      )}
    </>
  );
}